import * as R from 'ramda';

export default function MyReportsController(
  $q,
  $scope,
  $rootScope,
  $filter,
  userService,
  reportsDataService,
) {
  const vm = this;
  
  vm.reportInstanceTypes = [];
  vm.hasReportInstanceTypes = false;

  vm.filteredReportInstanceTypes = [];
  vm.hasFilteredReportInstanceTypes = false;
  
  vm.filterReportCategories = [];
  vm.filterReportNames = [];

  vm.showFilters = true;  

  vm.filter = {
    category: -1,
    reportName: -1,
  };

  vm.handleClearFilters = _handleClearFilters;
  vm.handleFilterChange = _handleFilterChange;

  _activate();

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function _activate() {
    vm.appIsLoaded = false;
    vm.showFilters = true;
   
    const promises = [
      _loadCustomerId(),
      reportsDataService.getMyReportInstanceSummary()
    ];

    return $q.all(promises).then((response) => {
      
      vm.reportInstanceTypes = response[1].data.result;
      vm.hasReportInstanceTypes = vm.reportInstanceTypes.length > 0;

      _extractFilterReportCategories(vm.reportInstanceTypes);
      _extractFilterReportNames(vm.reportInstanceTypes);

      _handleFilterChange();

      vm.appIsLoaded = true;
    });
  }

  function _initEventListeners() {
    $scope.$on('reports.myReports.reportTypeEmpty', (event, reportType) => {
      _handleDeletedReportType(reportType);
    });
  }

  /** ********************************************
   * Private Functions
   */
  
  function _handleClearFilters() {
    vm.filter.category = -1;
    vm.filter.reportName = -1;

    _handleFilterChange();
  } 

  function _handleDeletedReportType(reportType) {
    _remove(vm.filteredReportInstanceTypes);
    _remove(vm.reportInstanceTypes);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.uniqueId === reportType.uniqueId);
      if (pos === -1) {
        return; // Can't find the item
      }
      collection.splice(pos, 1);
    }
    
    _extractFilterReportCategories(vm.reportInstanceTypes);
    _extractFilterReportNames(vm.reportInstanceTypes);

    _handleFilterChange();
  }
  
  function _loadCustomerId() {
    return userService.getUser().then((user) => {
      vm.customerId = user.customerId;
    });
  }
  
  function _extractFilterReportCategories(reportInstanceTypes) {
    const _categories = [];
    const _categoryIds = [];

    R.forEach((reportInstanceType) => {
      let _found = false;
      const _categoryId = reportInstanceType.familyId;
      const _categoryName = reportInstanceType.familyName;

      R.forEach((categoryId) => {        
        if (categoryId === _categoryId) {
          _found = true;
        };
      }, _categoryIds);

      if (!_found) {
        const category = {
          id: _categoryId,
          name: _categoryName,
        };
        _categories.push(category);
        _categoryIds.push(_categoryId);
      }
    }, reportInstanceTypes);

    vm.filterReportCategories = R.sortBy(R.prop('name'), _categories);
  }
  
  function _extractFilterReportNames(reportInstanceTypes) {
    const _reportNames = [];
    const _reportIds = [];

    R.forEach((reportInstanceType) => {
      let _found = false;
      const _reportId = reportInstanceType.reportId;
      const _reportName = reportInstanceType.reportName;

      R.forEach((reportId) => {        
        if (reportId === _reportId) {
          _found = true;
        };
      }, _reportIds);

      if (!_found) {
        const reportName = {
          id: _reportId,
          name: _reportName,
        };
        _reportNames.push(reportName);
        _reportIds.push(_reportId);
      }
    }, reportInstanceTypes);

    vm.filterReportNames = R.sortBy(R.prop('name'), _reportNames);
  }
  
  function _handleFilterChange() {
    let _filteredReportInstanceTypes = vm.reportInstanceTypes;

    if (vm.filter.category !== -1) {
      _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { familyId: vm.filter.category });
    } 

    if (vm.filter.reportName !== -1) {
      _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { reportName: vm.filter.reportName });
    }

    _extractFilterReportNames(_filteredReportInstanceTypes);

    vm.filteredReportInstanceTypes = _filteredReportInstanceTypes;
    vm.hasFilteredReportInstanceTypes = vm.filteredReportInstanceTypes.length > 0;
  }
}

MyReportsController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  '$filter',
  'userService',
  'reportsDataService',
];
